module.exports = "pegasus/assets/background-patterns/mocha-grunge.png";